import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  Button, Form,
} from 'semantic-ui-react';

import CenterCard from './center_card';
import ErrorType from './types/error_type';
import {
  clearError, setCredentialData, sendSignInRequest,
} from '../modules/session';

import Loading from './loader_wave';
import ErrorMessage from './error_message';
import getParams from './utils/getParams';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
    };

    // Clear any existing errors, and then save the
    // email in the Redux store if window.location exists.
    const { connectedClearError, connectedSetCredentialData } = props;
    connectedClearError();
    const { e } = getParams(window.location);
    if (e) {
      connectedSetCredentialData('email', decodeURIComponent(e));
    }
  }

  componentWillUnmount() {
    const { connectedClearError } = this.props;
    connectedClearError();
  }

  setCredentialData = (event) => {
    const { connectedSetCredentialData } = this.props;
    if (event.target.name === 'password') {
      this.setState({ password: event.target.value });
    } else {
      connectedSetCredentialData(event.target.name, event.target.value);
    }
  }

  submitCredentials = (event) => {
    const { connectedSendSignInRequest } = this.props;
    const { password } = this.state;
    const { from } = getParams(window.location);
    event.preventDefault();
    connectedSendSignInRequest({ from, password });
  }

  renderForm = () => {
    const { email, signInRequestOut } = this.props;
    const { password } = this.state;
    return (
      <Form className="sign-in" onSubmit={this.submitCredentials}>
        <Form.Input type="email" name="email" placeholder="Email address" value={email} onChange={this.setCredentialData} required />
        <Form.Input type="password" name="password" placeholder="Password" value={password} onChange={this.setCredentialData} required />
        <div>
          <div className="re is-flex is-flex-row is-flex-align-center is-flex-justify-space-between">
            { signInRequestOut
              ? <Loading />
              : (
                <Button type="submit" primary>
                  Sign in
                </Button>
              )}
            {/* Because we don't care about passing a security audit, */}
            {/* we are going to ignore the remember me checkbox */}
            {/* <Checkbox */}
            {/*   checked={rememberMe} */}
            {/*   label="Remember me for a week" */}
            {/*   onChange={this.toggleRememberMe} */}
            {/* /> */}
          </div>
          <div className="re is-flex is-flex-row is-flex-justify-space-between is-marginTop-16px">
            <Link to="/forgot">Forgot password?</Link>
            {/* <Link to="/create">Sign up</Link> */}
          </div>
        </div>
      </Form>
    );
  }

  render() {
    const { error, routeName } = this.props;
    const msg = (error && error.error && error.error.message)
      || 'Unable to authenticate for that email and password.';
    return (
      <CenterCard routeName={routeName}>
        { this.renderForm() }
        { error && <ErrorMessage message={msg} /> }
      </CenterCard>
    );
  }
}

SignIn.propTypes = {
  connectedClearError: PropTypes.func.isRequired,
  connectedSendSignInRequest: PropTypes.func.isRequired,
  connectedSetCredentialData: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  error: ErrorType,
  routeName: PropTypes.string.isRequired,
  signInRequestOut: PropTypes.bool.isRequired,
};

SignIn.defaultProps = {
  error: undefined,
};

const mapStateToProps = (state) => ({
  email: state.session.email,
  error: state.session.error,
  signInRequestOut: state.session.signInRequestOut,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  connectedClearError: clearError,
  connectedSendSignInRequest: sendSignInRequest,
  connectedSetCredentialData: setCredentialData,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignIn);
